module.exports = __webpack_public_path__ + "static/media/ML_sagittal.d89f818c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ML_sagittal.jpg
// module id = 159
// module chunks = 0